import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSubjects } from './SubjectContext';
import { Subject } from './types';

const choiceClass =
  'block w-full rounded-lg border-2 border-gray-200 bg-white p-5 text-left transition-colors hover:border-gray-400 dark:border-gray-700 dark:bg-gray-800 disabled:opacity-60';

const AddSubject: React.FC = () => {
  const { catalogue, visible, addSubject } = useSubjects();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);
  const available = catalogue.filter((subject) => !visible.some((item) => item.id === subject.id));

  const pick = async (subject: Subject) => {
    if (saving) return;
    setSaving(true);
    setError(null);
    try {
      await addSubject(subject.id);
      navigate('/dashboard');
    } catch {
      setError('Could not add that subject. Try again.');
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 px-4 py-10 dark:bg-gray-900">
      <div className="mx-auto max-w-xl">
        <Link to="/dashboard" className="text-sm text-gray-600 dark:text-gray-300">
          ← Back
        </Link>
        <h1 className="mb-6 mt-4 text-2xl font-bold text-gray-900 dark:text-white">Add a subject</h1>
        {error && <p className="mb-4 text-sm text-red-600">{error}</p>}

        <div className="space-y-3">
          {available.length === 0 && (
            <p className="text-gray-600 dark:text-gray-400">You already have every subject we offer.</p>
          )}
          {available.map((subject) => (
            <button
              key={subject.id}
              type="button"
              className={choiceClass}
              disabled={saving}
              onClick={() => void pick(subject)}
            >
              <span className="flex items-center justify-between">
                <span className="text-lg font-semibold" style={{ color: subject.colour }}>
                  {subject.name}
                </span>
                <span className="rounded-full bg-gray-100 px-2 py-1 text-xs text-gray-700">{subject.tagline}</span>
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AddSubject;
